import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';
import displayName from 'component-lib/displayName';

import styles from './MenuItem.scss';

export default function MenuItem({
    isActive,
    name,
    path,
    goto,
    to,
    type,
    withoutReactRouterLinks,
}) {
    const className = `${type}${isActive ? '-active' : ''}`;

    return (
        <li className={styles.item}>
            {withoutReactRouterLinks && (
                <div
                    data-action={type}
                    data-active={isActive}
                    className={styles[className]}
                    role="presentation"
                    onClick={goto}
                >
                    {name}
                </div>
            )}

            {!withoutReactRouterLinks && (
                <Link
                    data-action={type}
                    data-active={isActive}
                    className={styles[className]}
                    to={to || path}
                >
                    {name}
                </Link>
            )}
        </li>
    );
}

MenuItem.displayName = displayName('LeftHandNav/MenuItem');

MenuItem.propTypes = {
    isActive: PropTypes.bool,
    path: PropTypes.string,
    to: PropTypes.string,
    type: PropTypes.string.isRequired,
    name: PropTypes.string,
    withoutReactRouterLinks: PropTypes.bool.isRequired,
    goto: PropTypes.func,
};

MenuItem.defaultProps = {
    isActive: false,
    path: '',
    to: '',
    name: '',
    goto: null,
};
